import React, { useCallback, useMemo, useState } from 'react'
import { Calculator } from '../types/Calculator'
import { CalculatorOutput } from '../types/CalculatorOutput'


const Totals = ( { totals: t, activeTargets, calculator }:Props ) => {

  const [ showDetails, setShowDetails ] = useState<boolean >( true )

  const totals = useMemo( () => {
    return t?.filter( ( t, i, self )=> {
      return self.findIndex( fi => fi.output?.id === t.output?.id ) === i &&
        t.output?.visible
    }) ?? []
  }, [ t ] )

  // const activeIndex = useMemo( () => {
  //   const index = totals?.findIndex( t => {
  //     return t.output?.id === activeTargets
  //   }) ?? totals.length + 1
  //   return index
  // }, [ totals, activeTargets ] )

  const toggleShowDetails = useCallback( () => {
    setShowDetails( prev => !prev )
  }, [] )

  const formatSeparators = useCallback( ( s:string ):string => {

    return s.split( '.' )
      .map( ( piece, i, real ) => {
        if( real.length > 1 && i === real.length - 1 ) return piece
        return piece
          .split( '' )
          .reverse()
          .map( ( s, i, real ) => {
            if( real.length / 3 <= 1 ) return s
              if( ( i + 1 ) % 3 === 0 && i !== ( real.length - 1 ) )
                return '.' + s;
            return s
          } )
          .reverse()
          .join( '' )
      })
      .join(',')

  }, [] )

  const getFormatedValue = useCallback( ( value:_Total ):string => {
    const decimals = value.output?.decimals ?? 0
    let _value:string = ''
    if( decimals > 0 )
      _value = formatSeparators( value.value.toFixed( decimals ) )
    else
      _value = formatSeparators( Math.round( value.value ).toString() )
      
    return (value.output?.prefix ?? '') + ` ${_value} ` +( value.output?.sufix ?? '' )
  }, [ formatSeparators ] )

  const general:_Total = useMemo( () => {

    let value = 0
    try {
      value = totals?.filter( 
        t => t.output?.sum_total ).map( 
          t => t.value ).reduce( 
            ( total, sum, ) => total + sum ) ?? 0

    } catch (error) { }

    return {
      label: 'Total',
      value,
      output: {
        id: 'TOTAL',
        name: 'total',
        decimals: 2
      }
    }
  }, [ totals ] )

  return (
    <div className="fixed w-full left-0 bottom-0 md:sticky md:top-0 ">
      <div className="container mx-auto grid md:grid-cols-5 gap-6">
        <div className="md:col-start-2 md:col-end-6">
          <div className={ ( showDetails ? 'max-h-screen-80' : 'max-h-0 overflow-hidden' )  + ' transition-all duration-300'}>
            {
              totals?.map( ( total, i ) => (
                <div 
                  key={ '_totals-' + i }
                  className={ "w-full h-14 px-2 border relative flex justify-between items-center " +
                    ( total.output?.id && activeTargets?.includes( total.output?.id ) ? "bg-white" : "bg-gray-100")
                  }
                >
                  {
                    total.output?.id && 
                    activeTargets?.includes( total.output?.id ) && 
                      <span className="md:block absolute z-10 left-0 w-0.5 h-full bg-green-500" />
                  }
                  <span> { total.label } </span>
                  <span> { getFormatedValue( total ) } </span>
                </div>
              ))
            }
          </div>       
          <div 
            onClick={ toggleShowDetails }
            className="w-full h-14 px-2 bg-black text-yellow-300 relative  flex justify-between items-center text-base relative md:pointer-events-none" 
          >
            {
              totals.length > 0 &&
                <span className="md:hidden absolute text-white top-0 w-full flex justify-center pointer-events-none" >
                  <i 
                    className="material-icons transition-all duration-300" 
                    onClick={ toggleShowDetails }
                    style={{
                      transform: !showDetails ? '' : 'rotate(-180deg)'
                    }}
                  >
                    keyboard_arrow_up
                  </i>
                </span>
            }
            <span>{ general?.label }</span>
            <span>{ getFormatedValue( general ) }</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export interface _Total{
  label: string,
  value: number,
  output?: CalculatorOutput
}
interface Props {
  activeTargets?: string[]
  totals?: _Total[]
  general?: _Total,
  calculator: Calculator
}
export { Totals }
